import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import Swal from '../../utils/darkSwal';
import BASE_URL from '../../utils/api';
import { useNavigate, Link } from 'react-router-dom';

export default function ResetPassword() {
  pageTitle('Reset Password');

  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleResetPassword = async () => {
    if (!email) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Email',
        text: 'Please enter your registered email.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    Swal.fire({
      title: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(`${BASE_URL}/api/users/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Password Reset',
          text: data.message || 'A new password has been sent to your email.',
          confirmButtonColor: '#1344af',
        }).then(() => {
          navigate('/login');
        });
        setEmail('');

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Reset Failed',
          text: data.message || 'Something went wrong.',
          confirmButtonColor: '#1344af',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Failed to connect to the server.',
        confirmButtonColor: '#1344af',
      });
    }
  };

  return (
    <>
      <PageHeading
        title="Reset Password"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Reset Password"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row justify-content-center">
          <Div className="col-lg-6">
            <h3 className="text-center cs-primary_color">Reset Your Password</h3>
            <Spacing lg="30" md="20" />

            <form action="#" className="row">
              <Div className="col-sm-12">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  className="cs-form_field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Spacing lg="30" md="20" />
              </Div>

              <Div className="col-sm-12 d-flex justify-content-center">
                <button
                  type="button"
                  className="cs-btn cs-style1"
                  onClick={handleResetPassword}
                >
                  <span>Send Reset Link</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>

              <Div className="col-sm-12 text-center mt-3">
                <p className="cs-primary_color">
                  Remembered your password?{' '}
                  <Link to="/login" style={{ color: '#1344af' }}>
                    Login here
                  </Link>
                </p>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="40" />
    </>
  );
}
